{
  "name": "medbook",
  "version": "3.1.82",
  "description": "Medbook",
  "private": true,
  "engines": {
    "node": "24.x.x",
    "npm": "11.x.x"
  },
  "scripts": {
    "start": "node backend/dist/index.js",
    "test": "cd backend && npm run test",
    "batch": "cd backend && npm run batch",
    "sync:logbook-type-info": "node scripts/sync-logbook-type-info.mjs",
    "sync:logbook-type-info:watch": "nodemon --watch backend/src/repositories/logbook-repository.ts --ext ts --exec \"npm run sync:logbook-type-info\"",
    "backend:watch": "cd backend && npm run dev:watch",
    "backend:tunnel:watch": "cd backend && npm run dev:watch:tunnel",
    "build": "cd backend && npm run build && cd .. && cd client && webpack --env production --mode production --config webpack.config.js && cd .. && cd promo && npm run build && cd .. && cd angular && npm run build",
    "sdk": "cd backend && npm run sdk",
    "sdk:watch": "cd backend && npm run sdk:watch",
    "angular:watch": "cd angular && npm run angular:watch",
    "promo:watch": "cd promo && npm run promo:watch",
    "react:watch": "cd client && webpack --watch",
    "dev:analyze": "cd client && webpack --analyze",
    "build:analyze": "cd client && webpack --analyze --env production",
    "dev:watch": "concurrently --names \"React,Angular,Backend,SDK\" -c \"bgGreen.bold,bgRed.bold,bgBlue.bold,bgMagenta.bold\" \"npm run react:watch\" \"npm run angular:watch\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "dev:watch:react": "concurrently --names \"React,Backend,SDK\" -c \"bgGreen.boldbgBlue.bold,bgMagenta.bold\" \"npm run react:watch\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "dev:watch:angular": "concurrently --names \"Angular,Backend,SDK\" -c \"bgRed.bold,bgBlue.bold,bgMagenta.bold\" \"npm run angular:watch\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "dev:watch:angular:prod": "concurrently --names \"AngularProd,Backend,SDK\" -c \"bgRed.bold,bgBlue.bold,bgMagenta.bold\" \"cd angular && npm run angular:watch:production\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "dev:watch:promo": "npm run promo:watch",
    "dev:watch:ionic": "concurrently --names \"Backend,App\" -c \"bgMagenta.bold,bgCyan.bold\" \"npm run backend:watch\" \"cd ionic && npm run serve:dev\"",
    "postinstall": "cd backend && npm i && cd .. && cd angular && npm i",
    "release": "generate-release"
  },
  "repository": {
    "type": "git"
  },
  "browserslist": {
    "production": [
      ">0.3%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "overrides": {
    "shell-quote": "^1.8.5",
    "serialize-javascript": "^7",
    "react-vis": {
      "react": "$react",
      "react-dom": "$react-dom"
    },
    "react-motion": {
      "react": "$react",
      "react-dom": "$react-dom"
    },
    "lodash": "^4.17.21",
    "basic-ftp": "^6.2.1"
  },
  "dependencies": {
    "@babel/cli": "^7.28.6",
    "@babel/core": "^7.29.0",
    "@babel/plugin-syntax-dynamic-import": "^7.8.3",
    "@babel/plugin-transform-class-properties": "^7.28.6",
    "@babel/plugin-transform-flow-strip-types": "^7.27.1",
    "@babel/plugin-transform-runtime": "^7.29.0",
    "@babel/preset-env": "^7.29.0",
    "@babel/preset-flow": "^7.27.1",
    "@babel/preset-react": "^7.28.5",
    "@babel/preset-typescript": "^7.28.5",
    "@babel/runtime": "^7.28.6",
    "@babel/runtime-corejs3": "^7.29.0",
    "@openapitools/openapi-generator-cli": "^2.30.1",
    "@redux-devtools/extension": "^3.3.0",
    "@reduxjs/toolkit": "^2.11.2",
    "@types/lodash": "^4.17.24",
    "@types/react": "^18.3.28",
    "@types/react-dom": "^18.3.7",
    "@types/react-modal": "^3.16.3",
    "@types/react-redux": "^7.1.34",
    "acorn": "^8.16.0",
    "axios": "^1.13.6",
    "babel-loader": "^9.2.1",
    "babel-plugin-lodash": "^3.3.4",
    "body-scroll-lock": "^3.1.5",
    "copy-webpack-plugin": "^11.0.0",
    "core-js": "^3.48.0",
    "css-loader": "^6.11.0",
    "dompurify": "^3.3.2",
    "fast-deep-equal": "^3.1.3",
    "formik": "^2.4.9",
    "history": "^5.3.0",
    "moment": "^2.30.1",
    "rc-pagination": "^3.7.0",
    "rc-tooltip": "^5.3.1",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "react-dropzone": "^14.4.1",
    "react-intl": "^6.8.9",
    "react-modal": "^3.16.3",
    "react-query": "^3.39.3",
    "react-quill-new": "^3.8.3",
    "react-redux": "^8.1.3",
    "react-router-dom": "^5.3.4",
    "react-toastify": "^9.1.3",
    "react-vis": "^1.12.1",
    "redux": "^4.2.1",
    "regenerator-runtime": "^0.13.11",
    "source-map-loader": "^4.0.2",
    "stacktrace-gps": "^3.1.2",
    "stacktrace-js": "^2.0.2",
    "style-loader": "^3.3.4",
    "ts-loader": "^9.5.4",
    "typescript": "^4.9.5",
    "url": "^0.11.4",
    "uuid": "^14.0.0",
    "validator": "^13.15.26",
    "webpack": "^5.105.4",
    "webpack-cli": "^5.1.4",
    "yup": "^1.7.1"
  },
  "devDependencies": {
    "@types/mocha": "^10.0.10",
    "@types/uuid": "^9.0.8",
    "@types/validator": "^13.15.10",
    "@typescript-eslint/eslint-plugin": "^5.62.0",
    "@typescript-eslint/parser": "^5.62.0",
    "app-root-path": "^3.1.0",
    "chai": "^5.3.3",
    "compression-webpack-plugin": "^10.0.0",
    "concurrently": "^8.2.2",
    "dotenv": "^16.6.1",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^8.10.2",
    "eslint-plugin-imengine": "file:eslint",
    "eslint-plugin-prettier": "^4.2.5",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^4.6.2",
    "express-openapi-validate": "^0.6.1",
    "generate-release": "^1.1.1",
    "html-webpack-plugin": "^5.6.6",
    "js-yaml": "^4.1.1",
    "lodash-webpack-plugin": "^0.11.6",
    "mini-css-extract-plugin": "^2.10.0",
    "mocha": "^10.8.2",
    "nodemon": "^3.1.14",
    "patch-package": "^6.5.1",
    "prettier": "^2.8.8",
    "supertest": "^6.3.4",
    "terser-webpack-plugin": "^5.3.17",
    "webpack-bundle-analyzer": "^4.10.2",
    "webpack-dev-server": "^4.15.2"
  }
,
"build":"master-38434-v3.1.82"}
